import React from 'react';

/* eslint-disable max-len */
const Icon = () => (
    <svg
        height="30"
        viewBox="0 0 31 26"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>TB-symbol</title>
        <defs>
            <path
                id="a"
                d="M10.08 13.843l3.315 8.58 15.357-5.063-3.586-9.127z"
            />
            <mask id="c" x="-2" y="-2" width="22.673" height="18.191">
                <path fill="#fff" d="M8.08 6.233h22.67v18.19H8.08z" />
                <use xlinkHref="#a" />
            </mask>
            <path id="b" d="M15.116 3.43l5.36 7.707L8.01 20.22l-5.068-7.202z" />
            <mask id="d" x="-2" y="-2" width="21.533" height="20.79">
                <path fill="#fff" d="M.942 1.43h21.533v20.79H.942z" />
                <use xlinkHref="#b" />
            </mask>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="rotate(-7 18.915 23.504)">
                <use fill="#FFF" xlinkHref="#a" />
                <use
                    stroke="#06BEFB"
                    mask="url(#c)"
                    strokeWidth="4"
                    xlinkHref="#a"
                />
            </g>
            <path
                fill="#06BEFB"
                d="M25.08 15.235l-2.652-4.975-1.085.583 2.678 4.92m-7.16-3.183c-1.59.846-2.2 2.828-1.353 4.427.845 1.6 2.823 2.21 4.418 1.364 1.597-.84 2.205-2.822 1.36-4.422s-2.823-2.21-4.42-1.363M15.338 20.1l-2.652-4.977-1.085.583 2.68 4.92"
            />
            <g transform="rotate(-20 11.208 14.66)">
                <use fill="#FFF" xlinkHref="#b" />
                <use
                    stroke="#06BEFB"
                    mask="url(#d)"
                    strokeWidth="4"
                    xlinkHref="#b"
                />
            </g>
            <path
                fill="#06BEFB"
                d="M11.65 5.594l4.43 3.08-.673.97-4.376-3.1m2.238 7.18c-.98 1.425-2.928 1.784-4.353.8-1.423-.98-1.785-2.935-.806-4.36.98-1.427 2.927-1.786 4.352-.803 1.425.988 1.787 2.94.808 4.368m-7.305.618l4.432 3.08-.674.97-4.375-3.1"
            />
        </g>
    </svg>
);

export default Icon;



// WEBPACK FOOTER //
// ./safeTrade/status/icon.jsx